import React, { useEffect, useState } from "react";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import EmailConstants from "../../Constants/EmailNotificationConstants";
import EmailNotificationAction from "../../Actions/EmailNotificationAction";
import emailStore from "../../Stores/EmailNotificationStore";
import { MdEdit, MdDelete, MdChromeReaderMode } from "react-icons/md";
import { useLanguageContext } from "../../Context/LanguageContext";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";
import { toast } from "react-toastify";
import CustomDataGrid from "../ReusableComponent/DataGrid/CustomizeDataGrid";
import { Button } from "@mui/material";
import { ColumneTypeDate } from "../ReusableComponent/DataGrid/ColumneTypeDate";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
export default function ScheduleEmailsList({
  handleTab,
  setScheduleEmailDetails,
  setViewMode,
}) {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [scheduleEmailList, setScheduleEmailList] = useState(null);
  const columns = [
    {
      field: "subject",
      headerName: localization.subject,
      hideable: false,
      flex: 1,
    },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
    { field: "emailType", headerName: localization.emailType, flex: 1 },
    { ...ColumneTypeDate("startDate", localization.startDate, localization) },
    {
      ...ColumneTypeDate("endDate", localization.endDate, localization),
    },
  ];

  /* <>--------------------------------------------------------------------Get Schedule Email Start----------------------------------------------------------<> */
  useEffect(() => {
    setGlobalSpinner(true);
    EmailNotificationAction.getScheduleEmail();
    function getScheduleEmailSuccess() {
      var res = emailStore.getResult();
      if (res.length > 0) {
        setScheduleEmailList(res);
      } else {
        setScheduleEmailList([]);
      }
      setGlobalSpinner(false);
    }

    function getScheduleEmailFailure() {
      var res = emailStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    emailStore.addChangeListener(
      EmailConstants.GET_SCHEDULE_EMAIL_SUCCESS,
      getScheduleEmailSuccess,
    );

    emailStore.addChangeListener(
      EmailConstants.GET_SCHEDULE_EMAIL_FAILURE,
      getScheduleEmailFailure,
    );
    return () => {
      emailStore.removeChangeListener(
        EmailConstants.GET_SCHEDULE_EMAIL_SUCCESS,
        getScheduleEmailSuccess,
      );

      emailStore.removeChangeListener(
        EmailConstants.GET_SCHEDULE_EMAIL_FAILURE,
        getScheduleEmailFailure,
      );
    };
  }, []);
  /* <>--------------------------------------------------------------------Get Schedule Email  End----------------------------------------------------------<> */
  /* <>--------------------------------------------------------------------Delete Email Start----------------------------------------------------------<> */
  useEffect(() => {
    function getScheduleEmailDeleteSuccess() {
      var res = emailStore.getResult();
      toast.success(localization.delSuccess);
      EmailNotificationAction.getScheduleEmail();
    }

    function getScheduleEmailDeleteFailure() {
      var res = emailStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    emailStore.addChangeListener(
      EmailConstants.DELETE_SCHEDULE_EMAIL_SUCCESS,
      getScheduleEmailDeleteSuccess,
    );

    emailStore.addChangeListener(
      EmailConstants.DELETE_SCHEDULE_EMAIL_FAILURE,
      getScheduleEmailDeleteFailure,
    );
    return () => {
      emailStore.removeChangeListener(
        EmailConstants.DELETE_SCHEDULE_EMAIL_SUCCESS,
        getScheduleEmailDeleteSuccess,
      );

      emailStore.removeChangeListener(
        EmailConstants.DELETE_SCHEDULE_EMAIL_FAILURE,
        getScheduleEmailDeleteFailure,
      );
    };
  }, []);
  /* <>--------------------------------------------------------------------Delete Schedule Email  End----------------------------------------------------------<> */
  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_Email":
          setGlobalSpinner(true);
          EmailNotificationAction.deleteScheduleEmail(data.ScheduleEmailID);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  function deleteCallback(id) {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.deleteConfirmation);
    setCallbackData({
      ScheduleEmailID: id,
    });
    setEventType("DELETE_Email");
  }

  function handleEdit(row) {
    setScheduleEmailDetails(row);
    handleTab(2);
  }

  function RenderEditButton() {
    return (
      <>
        <Button
          variant="outlined"
          id="editScheduleEmail"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<MdEdit />}
        >
          {localization.toolTipEdit}
        </Button>
      </>
    );
  }

  function handleDelete(row) {
    const _idList = [];
    if (Array.isArray(row)) {
      row.forEach((b) => _idList.push(b.id));
    } else {
      _idList.push(row.id);
    }
    deleteCallback(_idList);
  }

  function RenderDeleteButton(props) {
    const id = props.scheduleDetails;
    return (
      <>
        <Button
          variant="outlined"
          id="delEmailSchedule"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<MdDelete />}
        >
          {localization.delete}
        </Button>
      </>
    );
  }

  function handleReadModeButton(row) {
    setScheduleEmailDetails(row);
    setViewMode(true);
    handleTab(2);
  }

  function RenderReadModeButton() {
    return (
      <>
        <Button
          variant="outlined"
          id="delEmailSchedule"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<MdChromeReaderMode />}
        >
          {localization.toolTipView}
        </Button>
      </>
    );
  }

  const operations = {
    RowOperationList: [
      {
        label: "Edit",
        component: <RenderEditButton />,
        onClick: handleEdit,
      },
      {
        label: "delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
      {
        label: "ReadMode",
        component: <RenderReadModeButton />,
        onClick: handleReadModeButton,
      },
    ],
    GridToolBarAction: [],
    SelectedToolBar: [
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
  };
  function getAction(params) {
    const _acionList = [];

    _acionList.push(
      <GridActionsCellItem
        label={localization.toolTipEdit}
        showInMenu
        onClick={() => handleEdit(params.row)}
      />,
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.delete}
        showInMenu
        onClick={() => handleDelete(params.row)}
      />,
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.toolTipView}
        showInMenu
        onClick={() => handleReadModeButton(params.row)}
      />,
    );

    return _acionList;
  }
  return (
    <>
      <div className="w-100 h-100">
        {scheduleEmailList && (
          <CustomDataGrid
            Title={localization.scheduleEmails}
            columns={columns}
            rows={scheduleEmailList}
            operations={operations}
            onAdd={() => {}}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={["subject", "emailType", "startDate", "endDate"]}
            showCheckBox={true}
            gridTableHeight={"dataGridSmall"}
          />
        )}
      </div>
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
}
